import {closeAiActionLoadingModal, isCurrentModalSession, openShareLoadingModalAndGetSessionId} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {getPosterHashedIdForAiChatImageAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {openPosterSharingModal} from '@Modals/share-modal/share-modal-library';
import {CollabOpenedSource} from '@Libraries/ga-events';

export const shareUserDesign = (posterHashedId: string): void => {
  openPosterSharingModal(posterHashedId, CollabOpenedSource.AI_CHAT);
};

export async function shareAiChatImage(imageHashedId: string): Promise<void> {
  const sessionId = openShareLoadingModalAndGetSessionId();

  try {
    const posterHashedId = await getPosterHashedIdForAiChatImageAsset(imageHashedId);

    if (!isCurrentModalSession(sessionId)) {
      return;
    }

    openPosterSharingModal(posterHashedId, CollabOpenedSource.AI_CHAT);
  } catch (e: unknown) {
    console.error(e);
  } finally {
    if (isCurrentModalSession(sessionId)) {
      closeAiActionLoadingModal();
    }
  }
}
